<template>
  <div id="modalImportarTemplates">
    <q-dialog v-model="OpenDialogImportarTemplates" persistent>
      <q-card style="width: 900px; max-width: 95vw">
        <q-card-section class="row items-center no-wrap">
          <div class="text-h6">Importar templates da DouraSat</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="closeModal" />
        </q-card-section>
        <q-separator />

        <q-card-section>
          <q-banner dense class="bg-grey-2 q-mb-md">
            Estes são os templates que já existem na conta da DouraSat deste número.
            Importar cria uma cópia aqui apontando para o mesmo template aprovado na
            Meta — não é preciso pedir aprovação de novo.
          </q-banner>

          <div class="row q-col-gutter-md items-center q-mb-sm">
            <div class="col-12 col-md-6">
              <q-input
                v-model="busca"
                dense
                clearable
                label="Buscar pelo nome"
                debounce="300"
              />
            </div>
            <div class="col-12 col-md-6">
              <q-checkbox
                v-model="apenasAprovados"
                label="Mostrar apenas os aprovados"
              />
            </div>
          </div>

          <div v-if="carregando" class="text-center q-pa-lg">
            <q-spinner color="primary" size="2em" />
          </div>

          <div v-else-if="erro" class="text-negative q-pa-md">
            {{ erro }}
          </div>

          <div v-else-if="templatesFiltrados.length === 0" class="text-grey-7 q-pa-md">
            Nenhum template para mostrar com os filtros atuais.
          </div>

          <q-list v-else bordered separator style="max-height: 50vh; overflow-y: auto">
            <q-expansion-item
              v-for="template in templatesFiltrados"
              :key="template.template_id"
              expand-separator
            >
              <template v-slot:header>
                <q-item-section side top>
                  <q-checkbox
                    v-model="template.marcado"
                    :disable="template.ja_importado"
                    @update:model-value="limparAvisoDe"
                    @click.stop
                  />
                </q-item-section>
                <q-item-section>
                  <q-item-label lines="1">{{ template.nome }}</q-item-label>
                  <q-item-label caption lines="2">{{ template.body_remoto }}</q-item-label>
                </q-item-section>
                <q-item-section side top>
                  <div class="row items-center no-wrap">
                    <q-chip
                      dense
                      :color="corDoStatus(template.status)"
                      text-color="white"
                      :label="rotuloDoStatus(template.status)"
                    />
                    <q-chip
                      v-if="template.ja_importado"
                      dense
                      color="grey-6"
                      text-color="white"
                      label="Já importado"
                    />
                    <q-chip
                      v-else-if="pendencias(template).length > 0"
                      dense
                      color="orange"
                      text-color="white"
                      label="Requer mapeamento"
                    />
                  </div>
                </q-item-section>
              </template>

              <q-card>
                <q-card-section>
                  <div class="text-caption text-grey-7">Como a mensagem fica aqui dentro</div>
                  <div class="q-mb-md" style="white-space: pre-wrap">{{ previa(template) }}</div>

                  <div v-if="template.variaveis.length > 0">
                    <div class="text-caption text-grey-7 q-mb-xs">Variáveis</div>
                    <div class="row q-col-gutter-sm">
                      <div
                        v-for="variavel in template.variaveis"
                        :key="variavel.remota"
                        class="col-12 col-md-6"
                      >
                        <q-select
                          v-model="template.mapeamento[variavel.remota]"
                          :options="variaveisDisponiveis"
                          option-value="valor"
                          option-label="placeholder"
                          emit-value
                          map-options
                          dense
                          clearable
                          :label="'{{' + variavel.remota + '}}'"
                          :hint="variavel.resolvida
                            ? 'Reconhecida automaticamente'
                            : 'Escolha a variável equivalente'"
                          :error="!variavel.resolvida && !template.mapeamento[variavel.remota]"
                          error-message="Sem equivalente — o template não pode ser importado assim."
                        />
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-grey-7">Este template não usa variáveis.</div>
                </q-card-section>
              </q-card>
            </q-expansion-item>
          </q-list>

          <div v-if="erros.length > 0" class="q-mt-md">
            <div class="text-negative text-caption">Não foi possível importar:</div>
            <ul class="q-my-none">
              <li v-for="item in erros" :key="item.template_id" class="text-caption">
                {{ nomeDe(item.template_id) }} — {{ item.motivo }}
              </li>
            </ul>
          </div>
        </q-card-section>

        <q-separator />
        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Fechar" @click="closeModal" />
          <q-btn
            :loading="importando"
            :disable="marcados.length === 0"
            :label="'Importar ' + marcados.length + ' template(s)'"
            class="bg-positive text-white"
            @click="importar"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { Notify } from "quasar";
import { mapGetters } from "vuex";

const ROTULOS_STATUS = {
  approved: "Aprovado",
  pending: "Em análise",
  received: "Em análise",
  draft: "Rascunho",
  rejected: "Recusado",
  paused: "Pausado",
  disabled: "Desativado",
};

export default {
  name: "modal-importar-templates",
  data() {
    return {
      carregando: false,
      importando: false,
      erro: "",
      erros: [],
      busca: "",
      apenasAprovados: true,
      templates: [],
      variaveisDisponiveis: [],
    };
  },
  computed: {
    ...mapGetters(["OpenDialogImportarTemplates"]),
    templatesFiltrados() {
      const busca = (this.busca || "").trim().toLowerCase();

      return this.templates.filter(template => {
        if (this.apenasAprovados && template.status !== "approved") {
          // Um template marcado continua visível mesmo se o filtro mudar depois,
          // senão ele sairia da tela levando junto a seleção sem avisar.
          if (!template.marcado) return false;
        }
        if (!busca) return true;

        return template.nome.toLowerCase().indexOf(busca) !== -1;
      });
    },
    marcados() {
      return this.templates.filter(template => template.marcado && !template.ja_importado);
    },
  },
  methods: {
    closeModal() {
      this.$store.commit("OpenDialogImportarTemplates", false);
    },
    rotuloDoStatus(status) {
      return ROTULOS_STATUS[status] || status;
    },
    corDoStatus(status) {
      if (status === "approved") return "green";
      if (status === "rejected") return "red";
      if (status === "draft") return "grey-7";

      return "orange";
    },
    nomeDe(templateId) {
      const template = this.templates.find(item => item.template_id === templateId);

      return template ? template.nome : templateId;
    },
    // Variáveis que o backend não reconheceu e que o usuário ainda não apontou.
    pendencias(template) {
      return template.variaveis.filter(
        variavel => !variavel.resolvida && !template.mapeamento[variavel.remota]
      );
    },
    limparAvisoDe() {
      this.erros = [];
    },
    previa(template) {
      let corpo = template.body_local;

      template.variaveis.forEach(variavel => {
        const escolhido = template.mapeamento[variavel.remota];
        if (!escolhido) return;

        const opcao = this.variaveisDisponiveis.find(item => item.valor === escolhido);
        if (!opcao) return;

        corpo = corpo.split("{{" + variavel.remota + "}}").join(opcao.placeholder);
      });

      return corpo;
    },
    carregar() {
      this.carregando = true;
      this.erro = "";
      this.erros = [];

      return axios
        .get("/templates/importaveis-dourasat")
        .then(res => {
          this.carregando = false;

          // O interceptor resolve erro de HTTP como { error } — não há res.data.
          if (res.error || !res.data) {
            this.erro = "Não foi possível falar com a DouraSat, tente novamente.";
            this.templates = [];
            return;
          }

          if (!res.data.success) {
            this.erro = res.data.message || "Não foi possível listar os templates da DouraSat.";
            this.templates = [];
            return;
          }

          this.variaveisDisponiveis = res.data.variaveis_disponiveis || [];
          this.templates = (res.data.templates || []).map(template => {
            const mapeamento = {};
            template.variaveis.forEach(variavel => {
              // A sugestão já vem escolhida; variável reconhecida fica em branco
              // porque o backend a traduz sozinho.
              if (!variavel.resolvida && variavel.sugerida) {
                mapeamento[variavel.remota] = variavel.sugerida;
              } else {
                mapeamento[variavel.remota] = null;
              }
            });

            return Object.assign({}, template, {
              marcado: template.sugerir_marcado,
              mapeamento: mapeamento,
            });
          });
        })
        .catch(() => {
          this.carregando = false;
          this.erro = "Não foi possível falar com a DouraSat, tente novamente.";
        });
    },
    importar() {
      const pendentes = this.marcados.filter(template => this.pendencias(template).length > 0);

      if (pendentes.length > 0) {
        Notify.create({
          message:
            "Aponte o equivalente das variáveis destacadas em: " +
            pendentes.map(template => template.nome).join(", "),
          color: "orange",
          position: "top-right",
        });

        return;
      }

      this.importando = true;
      this.erros = [];

      axios
        .post("/templates/importar-dourasat", {
          templates: this.marcados.map(template => ({
            template_id: template.template_id,
            mapeamento: template.mapeamento,
          })),
        })
        .then(res => {
          this.importando = false;

          if (res.error || !res.data) {
            Notify.create({
              message: "Houve um erro ao importar os templates, tente novamente!",
              color: "red",
              position: "top-right",
            });
            return;
          }

          this.erros = res.data.erros || [];

          Notify.create({
            message: res.data.message,
            color: res.data.success ? "green" : "red",
            position: "top-right",
          });

          if (res.data.importados > 0) {
            // Relê a lista para os importados virarem "já importado" e sumirem
            // da seleção, em vez de o usuário mandar o mesmo de novo.
            this.carregar();
          }
        })
        .catch(() => {
          this.importando = false;

          Notify.create({
            message: "Houve um erro ao importar os templates, tente novamente!",
            color: "red",
            position: "top-right",
          });
        });
    },
  },
  watch: {
    OpenDialogImportarTemplates(aberto) {
      if (aberto) {
        this.carregar();
      }
    },
  },
};
</script>
